<template>
  <b-modal
    :visible="!!conflict"
    :title="title"
    hide-footer
    centered
    dialog-class="rx-conflict-dialog"
    @hide="onHide">
    <div v-if="conflict" class="rx-conflict">
      <p class="rx-conflict__intro">What would you like to do with the file you're uploading?</p>
      <div class="rx-conflict__options" role="group" aria-label="Choose how to handle the existing file">
        <button type="button" class="rx-conflict__opt" @click="answer('keep')">
          <i class="far fa-copy rx-conflict__icon" aria-hidden="true"></i>
          <span class="rx-conflict__text"><span class="rx-conflict__title">Keep both</span><span class="rx-conflict__sub">Uploads this one with a new name, like “Name (2)”</span></span>
        </button>
        <button type="button" class="rx-conflict__opt" @click="answer('replace')">
          <i class="fas fa-sync-alt rx-conflict__icon" aria-hidden="true"></i>
          <span class="rx-conflict__text"><span class="rx-conflict__title">Replace</span><span class="rx-conflict__sub">Overwrites the existing file; no history is kept</span></span>
        </button>
        <button ref="versionBtn" type="button" class="rx-conflict__opt is-default" @click="answer('version')">
          <i class="fas fa-history rx-conflict__icon" aria-hidden="true"></i>
          <span class="rx-conflict__text"><span class="rx-conflict__title">Upload as new version</span><span class="rx-conflict__sub">Keeps the earlier versions in the file's history</span></span>
        </button>
      </div>
      <label v-if="remaining > 0" class="rx-conflict__all">
        <input v-model="applyAll" type="checkbox" />
        Apply to all remaining conflicts ({{ remaining }})
      </label>
      <div class="rx-conflict__footer">
        <button type="button" class="rx-conflict__cancel" @click="answer('skip')">Cancel</button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConflictPrompt',
  props: {
    // { name, fileId, existingName, existingFileName, fileType } or null
    conflict: { type: Object, default: null },
    remaining: { type: Number, default: 0 }
  },
  data () {
    return {
      applyAll: false
    }
  },
  computed: {
    title () {
      if (!this.conflict) return ''
      var name = this.conflict.existingName || this.conflict.existingFileName || this.conflict.name
      return '“' + name + '” already exists in this folder'
    }
  },
  watch: {
    conflict: function (c) {
      var self = this
      this.applyAll = false
      this.answered = false
      if (!c) return
      this.$nextTick(function () {
        if (self.$refs.versionBtn) self.$refs.versionBtn.focus()
      })
    }
  },
  methods: {
    answer (choice) {
      if (!this.conflict || this.answered) return
      this.answered = true
      this.$emit('answer', { choice: choice, applyAll: this.applyAll === true })
    },
    onHide () {
      // Esc / backdrop / close button = Cancel (skip this file)
      if (this.conflict && !this.answered) this.answer('skip')
    }
  }
}
</script>

<style scoped>
.rx-conflict__intro {
  margin: 0 0 12px;
  color: #4b5563;
  font-size: 14px;
}
.rx-conflict__options {
  display: flex;
  flex-direction: column;
}
.rx-conflict__opt {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 56px;
  margin-bottom: 8px;
  padding: 8px 12px;
  border: 1px solid #e2e5ea;
  border-radius: 8px;
  background: #fff;
  color: #1f2937;
  text-align: left;
}
.rx-conflict__opt:hover {
  background: #f7f8fa;
}
.rx-conflict__opt.is-default {
  border-color: #1a7f86;
  background: #e3f1ef;
}
.rx-conflict__icon {
  flex: 0 0 28px;
  color: #1a7f86;
  font-size: 16px;
}
.rx-conflict__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.rx-conflict__title {
  font-weight: 600;
  font-size: 14px;
}
.rx-conflict__sub {
  font-size: 12px;
  color: #6b7280;
}
.rx-conflict__all {
  display: flex;
  align-items: center;
  min-height: 44px;
  margin: 4px 0 0;
  font-size: 14px;
  cursor: pointer;
}
.rx-conflict__all input {
  width: 18px;
  height: 18px;
  margin-right: 8px;
}
.rx-conflict__footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}
.rx-conflict__cancel {
  height: 44px;
  padding: 0 16px;
  border: 1px solid #e2e5ea;
  border-radius: 6px;
  background: #fff;
  color: #1f2937;
  font-weight: 600;
}
</style>

<style>
/* Phone: full-width dialog (b-modal renders outside the scoped tree) */
@media (max-width: 767.98px) {
  .modal-dialog.rx-conflict-dialog {
    max-width: none;
    margin: 0;
    min-height: 100%;
    align-items: flex-end;
  }
  .modal-dialog.rx-conflict-dialog .modal-content {
    border-radius: 12px 12px 0 0;
  }
}
</style>
